import { Order } from "../dto/orderSummaryTypes";
import { ProductListingProps } from "../types/ProductList";

/**
 * Maps backend error messages to user-friendly messages
 * @param errorMessage - Error message from backend
 * @param products - Available products list
 * @param orders - Current orders in edit mode
 * @returns Formatted user-friendly error message
 */
export const mapErrorMessage = (
  errorMessage: string,
  products: ProductListingProps[] = []
): string => {
  const cleanMessage = errorMessage.replace(/^Error:\s*/, "").trim();

  const inventoryPattern =
    /Insufficient inventory for productId:\s*([a-f0-9-]+)\s*\((\d+)L\)/i;
  const inventoryMatch = cleanMessage.match(inventoryPattern);

  if (inventoryMatch) {
    const productId = inventoryMatch[1].trim();
    const quantity = inventoryMatch[2];

    const product = products.find((p) => p.id === productId);
    const productName = product?.name || productId;

    return `${productName} for ${quantity}L is out of stock. Please edit the order again.`;
  }

  if (
    errorMessage.includes(
      "Cannot update order with duplicate productId and quantity"
    )
  ) {
    return "This product with the same keg size already exists in the order";
  }

  if (errorMessage.includes("has been processed or cancelled")) {
    return "This order cannot be edited as it has been processed or cancelled";
  }

  if (errorMessage.includes("Order Details are required")) {
    return "Order details are missing. Please add at least one product";
  }

  return errorMessage;
};
